webpackJsonp([13],{

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(337)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(342),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0c06d47f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 203:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(220)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(223),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-245f8eaa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,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");

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(221);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("7be071af", content, true, {});

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n@-webkit-keyframes spin {\nto {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n}\n}\n@keyframes spin-data-v-245f8eaa {\nto {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n}\n}\n.slinky-loader[data-v-245f8eaa] {\n  position: relative;\n  margin-top: 20px;\n  width: 40px;\n  aspect-ratio: 1;\n  border: 5px solid #555fff;\n  -webkit-animation: spin-data-v-245f8eaa infinite 0.8s linear forwards;\n          animation: spin-data-v-245f8eaa infinite 0.8s linear forwards;\n  border-radius: 50%;\n}\n.slinky-loader[data-v-245f8eaa]::after {\n  position: absolute;\n  content: \"\";\n  width: 30%;\n  aspect-ratio: 1;\n  top: 50%;\n  left: 100%;\n  -webkit-transform: translate(-25%, -50%);\n          transform: translate(-25%, -50%);\n  background: white;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/Slinky.vue"],"names":[],"mappings":";AACA;AACA;IACI,kCAAkC;YAC1B,0BAA0B;CACrC;CACA;AACD;AACA;IACI,kCAAkC;YAC1B,0BAA0B;CACrC;CACA;AACD;EACE,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,sEAAsE;UAC9D,8DAA8D;EACtE,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,yCAAyC;UACjC,iCAAiC;EACzC,kBAAkB;CACnB","file":"Slinky.vue","sourcesContent":["\n@-webkit-keyframes spin {\nto {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n}\n}\n@keyframes spin-data-v-245f8eaa {\nto {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n}\n}\n.slinky-loader[data-v-245f8eaa] {\n  position: relative;\n  margin-top: 20px;\n  width: 40px;\n  aspect-ratio: 1;\n  border: 5px solid #555fff;\n  -webkit-animation: spin-data-v-245f8eaa infinite 0.8s linear forwards;\n          animation: spin-data-v-245f8eaa infinite 0.8s linear forwards;\n  border-radius: 50%;\n}\n.slinky-loader[data-v-245f8eaa]::after {\n  position: absolute;\n  content: \"\";\n  width: 30%;\n  aspect-ratio: 1;\n  top: 50%;\n  left: 100%;\n  -webkit-transform: translate(-25%, -50%);\n          transform: translate(-25%, -50%);\n  background: white;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Slinky"
});

/***/ }),

/***/ 223:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slinky-loader"
  })
},staticRenderFns: []}

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__userService__ = __webpack_require__(46);



// Get access token
var getToken = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(googleCode) {
    var res, accessToken, _refreshToken, user;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(apiUrl + "/api-token-auth/", {
              access_token: googleCode
            });

          case 3:
            res = _context.sent;

            if (!(res && res.data)) {
              _context.next = 16;
              break;
            }

            console.log("USER IS LOGGED");
            accessToken = res.data.access_token;
            _refreshToken = res.data.refresh_token;

            if (!accessToken) {
              _context.next = 14;
              break;
            }

            console.log("added acc token to headers");
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
            _context.next = 13;
            return __WEBPACK_IMPORTED_MODULE_3__userService__["a" /* userService */].getUser();

          case 13:
            user = _context.sent;

          case 14:
            if (_refreshToken) window.localStorage.setItem("engrefresh", _refreshToken);
            return _context.abrupt("return", res.data);

          case 16:
            _context.next = 22;
            break;

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](0);

            console.log(_context.t0);
            return _context.abrupt("return", null);

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 18]]);
  }));

  return function getToken(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fixCSRFToken = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
    var res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;

            console.log("Testing CSRF token..");
            // Use a simple health check endpoint instead
            _context2.next = 4;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(apiUrl + "/health_check");

          case 4:
            res = _context2.sent;
            _context2.next = 10;
            break;

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);

            if (_context2.t0.response) {
              if (_context2.t0.response.status == 403) {
                console.log("Token failed.");
                delete_cookie("csrftoken_dev", "/", ".dev.app.morielenglish.co.il");
                delete_cookie("sessionid", "/", ".dev.app.morielenglish.co.il");
              }
            }

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[0, 7]]);
  }));

  return function fixCSRFToken() {
    return _ref2.apply(this, arguments);
  };
}();

// Get token from refresh
var refreshToken = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(refreshToken) {
    var res, accessToken, user;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(apiUrl + "/api-token-refresh/", {
              refresh: refreshToken
            });

          case 3:
            res = _context3.sent;

            if (!(res && res.data)) {
              _context3.next = 12;
              break;
            }

            accessToken = res.data.access;

            if (!accessToken) {
              _context3.next = 11;
              break;
            }

            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

            _context3.next = 10;
            return __WEBPACK_IMPORTED_MODULE_3__userService__["a" /* userService */].getUser();

          case 10:
            user = _context3.sent;

          case 11:
            return _context3.abrupt("return", res.data);

          case 12:
            _context3.next = 18;
            break;

          case 14:
            _context3.prev = 14;
            _context3.t0 = _context3["catch"](0);

            console.log(_context3.t0);
            if (_context3.t0.response) {
              if (_context3.t0.response.status == 401 || _context3.t0.response.status == 403) {
                window.localStorage.removeItem("engrefresh");
              }
            }
            // location.reload()

          case 18:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this, [[0, 14]]);
  }));

  return function refreshToken(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

// Handle authentication callback with tokens from URL


// Check current authentication state
var checkAuthState = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
    var refreshTokenFromStorage, result;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            refreshTokenFromStorage = window.localStorage.getItem("engrefresh");

            if (!refreshTokenFromStorage) {
              _context4.next = 24;
              break;
            }

            console.log("Auth state: Found refresh token, attempting to refresh access token");
            _context4.prev = 3;
            _context4.next = 6;
            return refreshToken(refreshTokenFromStorage);

          case 6:
            result = _context4.sent;

            if (!(result && result.access)) {
              _context4.next = 12;
              break;
            }

            console.log("Auth state: Successfully refreshed tokens");
            return _context4.abrupt("return", { authenticated: true });

          case 12:
            console.log("Auth state: Failed to refresh tokens");
            window.localStorage.removeItem("engrefresh");
            delete __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common["Authorization"];
            return _context4.abrupt("return", { authenticated: false });

          case 16:
            _context4.next = 24;
            break;

          case 18:
            _context4.prev = 18;
            _context4.t0 = _context4["catch"](3);

            console.error("Auth state: Error refreshing tokens:", _context4.t0);
            window.localStorage.removeItem("engrefresh");
            delete __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common["Authorization"];
            return _context4.abrupt("return", { authenticated: false });

          case 24:

            console.log("Auth state: No refresh token found");
            return _context4.abrupt("return", { authenticated: false });

          case 26:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this, [[3, 18]]);
  }));

  return function checkAuthState() {
    return _ref4.apply(this, arguments);
  };
}();

var apiUrl = "https://api.dev.app.morielenglish.co.il";
var googleLogin = apiUrl + "/google-direct/";
var googleClientID = "887990840804-eshjuu4g4glg3ufuf6p0ho40c0s1pnrt.apps.googleusercontent.com";

var authService = {
  refreshToken: refreshToken,
  getToken: getToken,
  logout: logout,
  fixCSRFToken: fixCSRFToken,
  googleLogin: googleLogin,
  googleClientID: googleClientID,
  handleAuthCallback: handleAuthCallback,
  checkAuthState: checkAuthState
};




__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.xsrfCookieName = "csrftoken_dev";
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.xsrfHeaderName = "X-CSRFToken";
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.withXSRFToken = true;
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.withCredentials = true;

function logout() {
  var logoutUrl = apiUrl + "/accounts/logout/";
  window.location.href = logoutUrl;
}

function delete_cookie(name, path, domain) {
  if (get_cookie(name)) {
    document.cookie = name + "=" + (path ? ";path=" + path : "") + (domain ? ";domain=" + domain : "") + ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
  }
}

function get_cookie(name) {
  return document.cookie.split(';').some(function (c) {
    return c.trim().startsWith(name + '=');
  });
}function handleAuthCallback() {
  var urlParams = new URLSearchParams(window.location.search);
  var accessToken = urlParams.get('access_token');
  var refreshToken = urlParams.get('refresh_token');
  var error = urlParams.get('error');

  if (error) {
    console.error('Auth callback error:', error);
    // Clear any existing tokens
    window.localStorage.removeItem("engrefresh");
    delete __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common["Authorization"];
    return { success: false, error: error };
  }

  if (accessToken && refreshToken) {
    console.log("Auth callback: Found tokens in URL");
    console.log("Auth callback: Access token (first 20 chars):", accessToken.substring(0, 20));
    console.log("Auth callback: Refresh token (first 20 chars):", refreshToken.substring(0, 20));

    // Store tokens
    window.localStorage.setItem("engrefresh", refreshToken);
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

    console.log("Auth callback: Stored refresh token in localStorage");
    console.log("Auth callback: Set Authorization header");
    console.log("Auth callback: localStorage now contains:", localStorage.getItem("engrefresh") ? "refresh token" : "no refresh token");

    // Clean URL
    var url = new URL(window.location);
    url.searchParams.delete('access_token');
    url.searchParams.delete('refresh_token');
    window.history.replaceState({}, document.title, url.toString());

    console.log("Auth callback: Tokens stored successfully");
    return { success: true, accessToken: accessToken, refreshToken: refreshToken };
  }

  return { success: false, message: 'No tokens found' };
}

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(270),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_authService__ = __webpack_require__(241);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "GoogleButton",
  methods: {
    redirect: function redirect() {
      window.location.href = "" + __WEBPACK_IMPORTED_MODULE_0__services_authService__["a" /* authService */].googleLogin;
    }
  }
});

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "main"
    }
  }, [_c('button', {
    staticClass: "fullBtn",
    on: {
      "click": function($event) {
        return _vm.redirect()
      }
    }
  }, [_c('inline-svg', {
    staticClass: "googleIcon",
    attrs: {
      "src": __webpack_require__(212).default
    }
  }), _vm._v("\n    " + _vm._s(_vm.$t("user.loginButton.button")) + "\n  ")], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(338);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("7ea5d5b9", content, true, {});

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.divMe[data-v-0c06d47f] {\n  font-weight: 500;\n  background-color: #555fff;\n  color: white;\n}\n.tblMain[data-v-0c06d47f] {\n  width: 100%;\n}\n.rankSqure[data-v-0c06d47f] {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  text-align: center;\n  width: 25%;\n}\n.loader[data-v-0c06d47f] {\n  text-align: center;\n  margin: 30px;\n}\n.top-users[data-v-0c06d47f] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  height: calc(100vh - 150px);\n  margin-bottom: 60px;\n  overflow: scroll;\n}\n.googleBtn[data-v-0c06d47f] {\n  width: 100%;\n  background-color: #555fff;\n  color: white;\n  text-align: center;\n  height: 60px;\n  font-size: 26px;\n  /* position: fixed;\n  bottom: 58px; */\n  z-index: 5;\n}\n@media (min-width: 780px) {\n.googleBtn[data-v-0c06d47f] {\n    width: 60%;\n}\n}\n.user[data-v-0c06d47f]:last-child {\n  margin-bottom: 125px;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/LeaderBoard/LeaderBoard.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,aAAa;CACd;AACD;EACE,YAAY;CACb;AACD;EACE,oBAAoB;MAChB,qBAAqB;UACjB,aAAa;EACrB,mBAAmB;EACnB,WAAW;CACZ;AACD;EACE,mBAAmB;EACnB,aAAa;CACd;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;EAC5B,oBAAoB;EACpB,iBAAiB;CAClB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB;kBACgB;EAChB,WAAW;CACZ;AACD;AACA;IACI,WAAW;CACd;CACA;AACD;EACE,qBAAqB;CACtB","file":"LeaderBoard.vue","sourcesContent":["\n.divMe[data-v-0c06d47f] {\n  font-weight: 500;\n  background-color: #555fff;\n  color: white;\n}\n.tblMain[data-v-0c06d47f] {\n  width: 100%;\n}\n.rankSqure[data-v-0c06d47f] {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  text-align: center;\n  width: 25%;\n}\n.loader[data-v-0c06d47f] {\n  text-align: center;\n  margin: 30px;\n}\n.top-users[data-v-0c06d47f] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  height: calc(100vh - 150px);\n  margin-bottom: 60px;\n  overflow: scroll;\n}\n.googleBtn[data-v-0c06d47f] {\n  width: 100%;\n  background-color: #555fff;\n  color: white;\n  text-align: center;\n  height: 60px;\n  font-size: 26px;\n  /* position: fixed;\n  bottom: 58px; */\n  z-index: 5;\n}\n@media (min-width: 780px) {\n.googleBtn[data-v-0c06d47f] {\n    width: 60%;\n}\n}\n.user[data-v-0c06d47f]:last-child {\n  margin-bottom: 125px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_userService__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__User_googleButton_vue__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__User_googleButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__User_googleButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__leaderBoard_scss__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__leaderBoard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__leaderBoard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Slinky_vue__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Slinky_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Shared_Slinky_vue__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "leader-board",
  data: function data() {
    return {
      showme: false,
      leaderboard: null,
      userProfile: null,
      newList: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              //need loader
              console.log("created leader board");

              if (!_this.user) {
                _context.next = 5;
                break;
              }

              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3__services_userService__["a" /* userService */].getLeaderBoard();

            case 4:
              _this.leaderboard = _context.sent;

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    userScore: function userScore() {
      if (this.user) {
        return this.user.score;
      }
    },
    userProfileNum: function userProfileNum() {
      if (this.user) {
        return this.user.profile_id;
      }
    }
  },
  watch: {
    user: function user() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__services_userService__["a" /* userService */].getLeaderBoard();

              case 2:
                _this2.leaderboard = _context2.sent;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    leaderboard: function leaderboard() {
      var _this3 = this;

      if (this.user) {
        var myScore = this.user.score;
        var myRank = this.user.user_rank;
        var a = void 0;
        var me = this.leaderboard.findIndex(function (res) {
          return res.id == _this3.userProfileNum;
        });
        console.log("ME", me);
        // if (me !== -1) {
        //   if (me + 1 == this.user.user_rank) {
        //     console.log("same rank");
        //     a = this.leaderboard;
        //   } else {
        //     const myUser = this.leaderboard.find(
        //       res => res.id == this.userProfileNum
        //     );
        //     console.log(this.userProfileNum);
        //     a = this.leaderboard.filter(res => res.id !== this.userProfileNum);
        //     console.log(a);
        //     a.splice(this.user.user_rank - 1, 0, myUser);
        //     console.log(a);
        //     this.userProfile = this.userProfileNum;
        //   }
        if (me !== -1) {
          if (me === 6) {
            a = this.leaderboard;
          } else {
            var place = this.leaderboard.findIndex(function (res) {
              return res.score == myScore;
            });
            var myUser = this.leaderboard.find(function (res) {
              return res.id == _this3.userProfileNum;
            });
            a = this.leaderboard.filter(function (res) {
              return res.id !== _this3.userProfileNum;
            });
            a.splice(place, 0, myUser);
          }
        } else {
          var _place = this.leaderboard.findIndex(function (res) {
            return res.score == myScore;
          });
          var _myUser = {
            id: this.userProfileNum,
            rank: myRank,
            score: myScore,
            rules_score: this.user.rules_score,
            words_score: this.user.words_score,
            sentences_score: this.user.sentences_score
          };
          a = this.leaderboard;
          a.splice(_place, 0, _myUser);
          this.userProfile = this.leaderboard.find(function (res) {
            return res.score == _this3.userScore;
          }).id || 0;
        }
        var newMe = a.findIndex(function (res) {
          return res.id == _this3.userProfileNum;
        });
        var startNum = myRank - newMe;
        this.newList = a.map(function (user, idx) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, user, { num: startNum + idx });
        });
        console.log(this.leaderboard);
        console.log(this.newList);
      }
      setTimeout(function () {
        document.documentElement.style.scrollBehavior = "smooth";
        // const topPosition = document.querySelector(".container").scrollIntoView({
        //   behavior: "smooth",
        //   block: "start",
        //   inline: "start"
        // });
        var topPosition = document.querySelector(".divMe");
        window.scroll({
          behavior: "smooth",
          top: topPosition.offsetTop - 250,
          left: 0
        });
      }, 250);
    }
  },
  components: {
    GoogleButton: __WEBPACK_IMPORTED_MODULE_4__User_googleButton_vue___default.a,
    SlinkyVue: __WEBPACK_IMPORTED_MODULE_6__Shared_Slinky_vue___default.a
  }
});

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(341);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("a4e84f68", content, true, {});

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".leader-board{font-size:20px;font-weight:400}.leader-board .title{text-align:center;color:#3b3b8c}.leader-board .user{display:flex;flex-grow:1;min-height:70px;align-items:center;border-bottom:1px solid #ddd}.leader-board .user .idx{min-width:1em}.leader-board .user .displayName{flex:3;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}@media(max-width: 37.5em){.leader-board .user .displayName{margin-left:10px}}.leader-board .user .knows{justify-content:space-between;font-weight:bold;flex:1.2}@media(max-width: 37.5em){.leader-board .user .knows{flex:4}}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/LeaderBoard/src/components/LeaderBoard/leaderBoard.scss","/__w/lang_app_eng/lang_app_eng/src/components/LeaderBoard/src/scss/abstracts/_variables.scss","/__w/lang_app_eng/lang_app_eng/src/components/LeaderBoard/src/scss/abstracts/_mixins.scss"],"names":[],"mappings":"AAEA,cACE,eACA,eAAA,CACA,qBACE,kBACA,aCLU,CDUZ,oBACE,aACA,YACA,gBACA,mBACA,4BAAA,CACA,yBACE,aAAA,CAEF,iCACE,OACA,uBACA,mBACA,eAAA,CENF,0BFEA,iCAMI,gBAAA,CAAA,CAGJ,2BACE,8BACA,iBACA,QAAA,CEdF,0BFWA,2BAKI,MAAA,CAAA,CAAA","file":"leaderBoard.scss","sourcesContent":["@import \"../../scss/abstracts/variables\";\n@import \"../../scss/abstracts/mixins\";\n.leader-board {\n  font-size: 20px;;\n  font-weight: 400;\n  .title {\n    text-align: center;\n    color: $blue-dark-1;\n  }\n  // .user:last-child {\n  //   margin-bottom: 60px;\n  // }\n  .user {\n    display: flex;\n    flex-grow: 1;\n    min-height: 70px;\n    align-items: center;\n    border-bottom: 1px solid #dddddd;\n    .idx {\n      min-width: 1em;\n    }\n    .displayName {\n      flex: 3;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n      @include respon(phone) {\n        margin-left: 10px;\n      }\n    }\n    .knows {\n      justify-content: space-between;\n      font-weight: bold;\n      flex: 1.2;\n      @include respon(phone) {\n        flex: 4;\n      }\n    }\n  }\n}\n","//BLUE\n$blue-dark-0: #1f1f55;\n$blue-dark-1: #3b3b8c;\n$blue: #5555ff;\n$blue-light-1: #85a2ff;\n$blue-light-2: #d1d5ff;\n//RED\n$red: #ff4063;\n$red-light: #ff728c;\n$purple: #40134a;\n//GREEN\n$green: #41d988;\n$green-icon: #7de37d;\n//PINK\n$pink: #ffa3ff;\n\n//ORANGE\n$orange: #fa5;\n\n//BROWN\n$brown: #5a3000;\n","@mixin absCenter {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n//media query\n//1em=16px\n// em and rem in media query always equall fs from browser =16px unless user change it.\n//rem failed work with some of browrswers\n@mixin respon($breakpoint) {\n  @if $breakpoint==no-phone {\n    @media (min-width: 37.5em) {\n      //600px\n      @content;\n    }\n  }\n  @if $breakpoint==phone {\n    @media (max-width: 37.5em) {\n      //600px\n      @content;\n    }\n  }\n  @if $breakpoint==700px {\n    @media (max-width: 43.75em) {\n      //700px\n      @content;\n    }\n  }\n  @if $breakpoint==tab-port {\n    @media (max-width: 56.25em) {\n      //900px\n      @content;\n    }\n  }\n\n  @if $breakpoint==tab-land {\n    @media (max-width: 75em) {\n      //1200px\n      @content;\n    }\n  }\n  @if $breakpoint==big-desktop {\n    //1800px\n    @media (min-width: 112.5em) {\n      @content;\n    }\n  }\n}\n\n@mixin aspect-ratio($width, $height) {\n  position: relative;\n  overflow: hidden;\n  &:before {\n    display: block;\n    content: \"\";\n    width: 100%;\n    padding-top: ($height / $width) * 100%;\n  }\n  > * {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n  }\n\n  > img {\n    object-fit: cover;\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 342:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leader-board"
  }, [(!_vm.user) ? _c('div', {
    staticClass: "loader"
  }, [_c('p', {
    staticStyle: {
      "margin": "40px"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("leaderBoard.leaderBoard.register-only")) + "\n    ")]), _vm._v(" "), _c('LoginButton', {
    staticClass: "googleBtn"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.leaderboard) ? _c('div', {
    staticClass: "loader"
  }, [_vm._v("\n    " + _vm._s(_vm.$t("leaderBoard.leaderBoard.loading")) + "\n    "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "justify-content": "center",
      "margin": "8px"
    }
  }, [_c('SlinkyVue')], 1)]) : _vm._e(), _vm._v(" "), (_vm.newList) ? _c('div', {
    staticClass: "top-users"
  }, _vm._l((_vm.newList), function(ruser, idx) {
    return _c('div', {
      key: idx,
      staticClass: "user",
      class: {
        divMe: _vm.userProfileNum == ruser.id
      }
    }, [_c('div', {
      staticClass: "idx rankSqure"
    }, [_vm._v(_vm._s(ruser.num))]), _vm._v(" "), _c('div', {
      staticClass: "laws rankSqure"
    }, [_vm._v(_vm._s(ruser.words_score))]), _vm._v(" "), _c('div', {
      staticClass: "words rankSqure"
    }, [_vm._v(_vm._s(ruser.rules_score / 5))]), _vm._v(" "), _c('div', {
      staticClass: "sentance rankSqure"
    }, [_vm._v(_vm._s(ruser.sentences_score / 10))])])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// 13.ce03fd3d81a126f24b18.bundle.js